"use client";
import * as React from "react";
const SvgSentimentVerySatisfiedOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M7.992 0A7.991 7.991 0 0 0 0 8c0 4.424 3.576 8 7.992 8S16 12.424 16 8a8 8 0 0 0-8.008-8ZM8 14.4A6.398 6.398 0 0 1 1.6 8c0-3.536 2.864-6.4 6.4-6.4 3.536 0 6.4 2.864 6.4 6.4 0 3.536-2.864 6.4-6.4 6.4Zm.8-8.048.848.848.848-.848.848.848.848-.848-1.696-1.696L8.8 6.352Zm-3.296 0 .848.848.848-.848-1.696-1.696-1.696 1.696.848.848.848-.848ZM8 12.4a4.397 4.397 0 0 0 4.088-2.8H3.912A4.397 4.397 0 0 0 8 12.4Z" }));
export {
  SvgSentimentVerySatisfiedOutlined as default
};
